var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "msgSelect" },
    [
      _c(
        "el-radio-group",
        {
          staticClass: "radioGroup",
          on: { change: _vm.onTypeChange },
          model: {
            value: _vm.radio,
            callback: function ($$v) {
              _vm.radio = $$v
            },
            expression: "radio",
          },
        },
        _vm._l(_vm.msgTypeOption, function (item) {
          return _c(
            "el-radio",
            {
              key: item.value,
              staticClass: "radioGroupItem",
              attrs: { label: item.value },
            },
            [_vm._v(_vm._s(item.label))]
          )
        }),
        1
      ),
      _c(
        "div",
        { staticClass: "msgContent m-t-10" },
        [
          _vm.radio === 1 || _vm.radio === 11
            ? [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: 3,
                    placeholder: "请输入内容",
                    maxlength: "100",
                    "show-word-limit": "",
                    disabled: "",
                  },
                  model: {
                    value: _vm.content,
                    callback: function ($$v) {
                      _vm.content = $$v
                    },
                    expression: "content",
                  },
                }),
              ]
            : _vm.radio === 3
            ? [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: 3,
                    placeholder: "请输入内容",
                    maxlength: "200",
                    "show-word-limit": "",
                  },
                  model: {
                    value: _vm.content,
                    callback: function ($$v) {
                      _vm.content = typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "content",
                  },
                }),
              ]
            : _vm.radio === 2
            ? [
                _c(
                  "el-image",
                  {
                    staticStyle: { width: "100px", height: "100px" },
                    attrs: { fit: "contain", src: _vm.iamgeUrl },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "image-slot",
                        attrs: { slot: "error" },
                        slot: "error",
                      },
                      [_c("i", { staticClass: "el-icon-loading" })]
                    ),
                  ]
                ),
              ]
            : _vm.radio === 5
            ? [
                _c(
                  "div",
                  { staticClass: "emoji-box" },
                  _vm._l(_vm.emojiList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "emojiView",
                        class: { emojiActive: _vm.content === item.name },
                        on: {
                          click: function ($event) {
                            return _vm.pickEmoji(index)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "emoji-img",
                          attrs: {
                            src: item.value,
                            alt: item.name,
                            title: item.name,
                          },
                        }),
                      ]
                    )
                  }),
                  0
                ),
              ]
            : _vm.radio === 4
            ? [
                _c("upload", {
                  ref: "MUpload",
                  attrs: {
                    width: "160",
                    height: "120",
                    accept: ".jpg,.jpeg,.png",
                    "before-upload": _vm.beforeUpload,
                    "max-length": 1,
                    "oss-teacher-folder": "hok_liveRoom",
                  },
                  on: { onClick: _vm.delImage, change: _vm.fileChange },
                }),
              ]
            : _vm.radio === 8
            ? [_vm._m(0)]
            : _vm.radio === 9
            ? [_vm._m(1)]
            : _vm.radio === 10
            ? [_vm._m(2)]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "shoping_comment_content" }, [
      _c("div", { staticClass: "shoping" }, [
        _c("img", {
          staticClass: "shopingIcon",
          attrs: { src: require("@/assets/image/liveRoom/shopCar.png") },
        }),
        _c("div", { staticClass: "shopingText" }, [
          _c("img", {
            staticStyle: { width: "66px", height: "14px" },
            attrs: { src: require("@/assets/image/live/zhengzaigoumai.png") },
          }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "shoping_comment_content" }, [
      _c("div", { staticClass: "shoping shoped" }, [
        _c("img", {
          staticClass: "shopingIcon",
          attrs: { src: require("@/assets/image/liveRoom/shopCar.png") },
        }),
        _c("div", { staticClass: "shopingText" }, [
          _c("img", {
            staticStyle: { width: "50px", height: "15px" },
            attrs: { src: require("@/assets/image/live/yigoumai.png") },
          }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "shoping_comment_content" }, [
      _c("div", { staticClass: "shoping yilingquyouhuiquan" }, [
        _c("img", {
          staticClass: "shopingIcon",
          staticStyle: { width: "18px", height: "18px" },
          attrs: { src: require("@/assets/image/live/hot.png") },
        }),
        _c("div", { staticClass: "shopingText" }, [
          _c("img", {
            staticStyle: { width: "99px", height: "15px" },
            attrs: {
              src: require("@/assets/image/live/yilingquyouhuiquan.png"),
            },
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }